/* ============================================================
   Mybibblio — paid add-ons on the product page
   • Hardback upgrade (+£6.99) — format option cards
   • Personal dedication (+£3.99) — checkbox + message box

   When at least one add-on is selected, we take over add-to-cart
   so we can add the book + the add-on(s) together. We intercept
   the BUTTON CLICK in the capture phase (before the theme's own
   click/submit handlers) so the book is only ever added ONCE.
   When no add-on is selected, the theme's normal add runs untouched.
   ============================================================ */
(function () {
  var PRESIGN_URL = 'https://mybibbliobooks.onrender.com/uploads/presign';

  function cartUrl() {
    try { if (window.Theme && Theme.routes && Theme.routes.cart_url) return Theme.routes.cart_url; } catch (e) {}
    return '/cart';
  }

  // The cart-drawer + cart-icon listen for a 'cart:update' event and refresh from
  // rendered `sections`. After a custom add we fire that event (like the theme's own
  // form) so the drawer opens and the cart refreshes — instead of redirecting to /cart.
  function getCartSectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component').forEach(function (c) {
      if (c.dataset && c.dataset.sectionId) ids.push(c.dataset.sectionId);
    });
    return ids.join(',');
  }
  function notifyCartUpdated() {
    // No cart drawer on the page -> fall back to the old behaviour so the shopper still gets feedback.
    if (!document.querySelector('cart-drawer-component')) { window.location.href = cartUrl(); return Promise.resolve(); }
    var ids = getCartSectionIds();
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(ids ? { sections: ids } : {})
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var evt = new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cart, sourceId: 'mybibblio-addons', data: { source: 'product-form-component', sections: cart.sections } }
        });
        document.dispatchEvent(evt);
      })
      .catch(function () { window.location.href = cartUrl(); });
  }

  // Dedication: reveal/hide + require the message box
  function setupDedication(root) {
    if (root.dataset.kbDedInit === '1') return;
    var check = root.querySelector('[data-kb-ded-check]');
    var panel = root.querySelector('[data-kb-ded-panel]');
    var text = panel && panel.querySelector('textarea');
    if (!check || !panel || !text) return;
    root.dataset.kbDedInit = '1';
    check.addEventListener('change', function () {
      if (check.checked) {
        panel.hidden = false; text.disabled = false; text.required = true;
        try { text.focus(); } catch (e) {}
      } else {
        panel.hidden = true; text.disabled = true; text.required = false; text.value = '';
      }
    });
  }

  // Shared fullscreen photo preview (lightbox)
  var _lb = null;
  function closeLightbox() { if (_lb) { _lb.hidden = true; document.documentElement.style.overflow = ''; } }
  function openLightbox(src) {
    if (!src) return;
    if (!_lb) {
      _lb = document.createElement('div');
      _lb.className = 'kb-lightbox';
      _lb.hidden = true;
      _lb.innerHTML = '<button type="button" class="kb-lightbox__close" aria-label="Close">×</button><img alt="Your photo at full size">';
      _lb.addEventListener('click', function (e) {
        if (e.target === _lb || (e.target.classList && e.target.classList.contains('kb-lightbox__close'))) closeLightbox();
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeLightbox(); });
      document.body.appendChild(_lb);
    }
    _lb.querySelector('img').src = src;
    _lb.hidden = false;
    document.documentElement.style.overflow = 'hidden';
  }

  // A photo inside a disabled fieldset (a removed second child) is never
  // submitted, so it must never hold up add-to-cart either.
  function photoLive(root) { return !(root.closest && root.closest('fieldset[disabled]')); }
  function liveUploads() {
    var busy = [];
    document.querySelectorAll('[data-kb-photo][data-kb-up="1"]').forEach(function (r) { if (photoLive(r)) busy.push(r); });
    return busy;
  }
  function refreshUploading(form) { if (form) form.classList.toggle('kb-uploading', liveUploads().length > 0); }

  // Second child: the "One child / Two children" choice shows or hides the
  // second card (its Remove link goes back to one). The card is a <fieldset>
  // whose `disabled` flag keeps every field inside it out of validation and
  // out of the order unless two children are chosen.
  function kidsForm(box) {
    var i = box.querySelector('[data-kb-name]');
    return i && (i.form || document.getElementById(i.getAttribute('form')));
  }
  function setupKids(box) {
    if (box.dataset.kbKidsInit === '1') return;
    var counts = [].slice.call(box.querySelectorAll('[data-kb-kids-count]'));
    var kid2 = box.querySelector('[data-kb-kid="2"]');
    if (!counts.length || !kid2) return;
    box.dataset.kbKidsInit = '1';
    var rm = kid2.querySelector('[data-kb-kid-remove]');
    var oneBtn = box.querySelector('[data-kb-kids-count="1"]');
    function set(on, focus) {
      kid2.disabled = !on;
      kid2.hidden = !on;
      counts.forEach(function (b) {
        var sel = (b.getAttribute('data-kb-kids-count') === '2') === on;
        b.classList.toggle('is-on', sel);
        b.setAttribute('aria-pressed', sel ? 'true' : 'false');
      });
      // card titles read "First child / Second child" with two, "Your little star" with one
      box.querySelectorAll('[data-kb-kid-title]').forEach(function (t) {
        var def = t.getAttribute(on ? 'data-default-two' : 'data-default-one');
        if (def) t.setAttribute('data-default', def);
        var kid = t.closest('[data-kb-kid]');
        var nm = kid && kid.querySelector('[data-kb-name]');
        if (!nm || !nm.value.trim()) t.textContent = t.getAttribute('data-default') || '';
      });
      document.documentElement.classList.toggle('kb-kids-2', on);
      refreshUploading(kidsForm(box));
      if (!focus) return;
      if (on) {
        kid2.classList.remove('kb-kid--in'); void kid2.offsetWidth; kid2.classList.add('kb-kid--in');
      } else if (oneBtn) {
        try { oneBtn.focus({ preventScroll: true }); } catch (e) {}
      }
    }
    counts.forEach(function (b) {
      b.addEventListener('click', function () {
        var want = b.getAttribute('data-kb-kids-count') === '2';
        if (want !== !kid2.disabled) set(want, true);
      });
    });
    if (rm) rm.addEventListener('click', function () {
      set(false, true);
      try { box.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) {}
    });
    box._kbSetKid2 = set;
  }

  // Photo: choose / drag-and-drop / preview / enlarge
  function setupPhoto(root) {
    if (root.dataset.kbPhotoInit === '1') return;
    var zone = root.querySelector('[data-kb-photo-zone]');
    var input = root.querySelector('[data-kb-photo-input]');
    var prompt = root.querySelector('[data-kb-photo-prompt]');
    var preview = root.querySelector('[data-kb-photo-preview]');
    var img = root.querySelector('[data-kb-photo-img]');
    var nameEl = root.querySelector('[data-kb-photo-name]');
    var errEl = root.querySelector('[data-kb-photo-error]');
    var thumb = root.querySelector('[data-kb-photo-thumb]');
    var change = root.querySelector('[data-kb-photo-change]');
    var remove = root.querySelector('[data-kb-photo-remove]');
    var urlInput = root.querySelector('[data-kb-photo-url]');
    var statusEl = root.querySelector('[data-kb-photo-status]');
    var form = input.form || document.getElementById(input.getAttribute('form'));
    if (!zone || !input || !prompt || !preview || !img) return;
    root.dataset.kbPhotoInit = '1';

    // Wake the (possibly asleep) upload backend on page load, so it's warm by upload time.
    try { fetch(PRESIGN_URL, { method: 'GET', mode: 'no-cors', cache: 'no-store' }).catch(function () {}); } catch (e) {}

    var objectUrl = null;
    var OK = ['image/jpeg', 'image/png', 'image/webp'];
    var HEIC_MSG = 'Please choose a JPEG or PNG. On iPhone: Settings → Camera → Formats → Most Compatible, or share the photo to convert it.';

    // Sniff the real file type from magic bytes — iOS reports HEIC inconsistently,
    // so the reported MIME type alone can't be trusted.
    function sniffType(file) {
      return new Promise(function (res) {
        var fr = new FileReader();
        fr.onload = function () {
          var b = new Uint8Array(fr.result);
          function str(o, l) { var s = ''; for (var i = o; i < o + l && i < b.length; i++) s += String.fromCharCode(b[i]); return s; }
          if (b[0] === 0xFF && b[1] === 0xD8) return res('jpeg');
          if (b[0] === 0x89 && str(1, 3) === 'PNG') return res('png');
          if (str(0, 4) === 'RIFF' && str(8, 4) === 'WEBP') return res('webp');
          if (str(4, 4) === 'ftyp') {
            var brand = str(8, 4).toLowerCase();
            if (/heic|heix|hevc|hevx|heif|mif1|msf1/.test(brand)) return res('heic');
          }
          res('unknown');
        };
        fr.onerror = function () { res('unknown'); };
        fr.readAsArrayBuffer(file.slice(0, 16));
      });
    }

    // Auto-convert HEIC -> JPEG in the browser where the platform can decode it
    // (iOS/macOS Safari decode HEIC natively — exactly where HEIC uploads come from).
    function convertHeic(file) {
      return new Promise(function (res, rej) {
        var url = URL.createObjectURL(file);
        var im = new Image();
        im.onload = function () {
          try {
            var w = im.naturalWidth, h = im.naturalHeight;
            if (!w || !h) { URL.revokeObjectURL(url); return rej(new Error('no-dims')); }
            var c = document.createElement('canvas');
            c.width = w; c.height = h;
            c.getContext('2d').drawImage(im, 0, 0);
            c.toBlob(function (b) {
              URL.revokeObjectURL(url);
              if (!b) return rej(new Error('no-blob'));
              var nm = ((file.name || 'photo').replace(/\.[^.]+$/, '') || 'photo') + '.jpg';
              try { res(new File([b], nm, { type: 'image/jpeg' })); }
              catch (e) { b.name = nm; res(b); }   // very old browsers without File()
            }, 'image/jpeg', 0.92);
          } catch (e) { URL.revokeObjectURL(url); rej(e); }
        };
        im.onerror = function () { URL.revokeObjectURL(url); rej(new Error('decode')); };
        im.src = url;
      });
    }

    function showErr(m) { if (errEl) { errEl.textContent = m; errEl.hidden = false; } }
    function clearErr() { if (errEl) { errEl.hidden = true; errEl.textContent = ''; } }
    function setStatus(msg, kind) {
      if (!statusEl) return;
      if (!msg) { statusEl.hidden = true; statusEl.textContent = ''; return; }
      statusEl.hidden = false; statusEl.textContent = msg;
      statusEl.className = 'kb-photo__status' + (kind === 'ok' ? ' is-ok' : '');
    }
    // Each photo block tracks its own upload; the form is "uploading" while ANY
    // photo that will actually be submitted is still in flight.
    function setUploading(on) { root.setAttribute('data-kb-up', on ? '1' : '0'); refreshUploading(form); }
    var photoProp = (urlInput && urlInput.getAttribute('name')) || 'properties[_Child photo]';
    var gen = 0;   // bumps on Remove, so a late upload result for a removed photo is ignored

    // A small preview of the chosen photo, kept in this browser only so the cart can
    // show it (the stored photo itself is private). See kbThumbs in mybibblio-cart.js.
    var thumbData = null, thumbFor = null;
    function makeThumb(im) {
      try {
        var w = im.naturalWidth, h = im.naturalHeight;
        if (!w || !h) return null;
        var k = Math.min(1, 400 / Math.max(w, h));
        var c = document.createElement('canvas');
        c.width = Math.round(w * k); c.height = Math.round(h * k);
        var ctx = c.getContext('2d');
        if (!ctx) return null;
        ctx.drawImage(im, 0, 0, c.width, c.height);
        return c.toDataURL('image/jpeg', 0.72);
      } catch (e) { return null; }
    }
    function rememberThumb() {
      if (!thumbData || !thumbFor) return;
      try { if (window.kbThumbs) window.kbThumbs.save(thumbFor, thumbData); } catch (e) {}
      thumbFor = null;
    }

    // Direct PUT to storage with progress
    function putFile(p, file) {
      return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open(p.method || 'PUT', p.uploadUrl);
        var h = p.headers || {};
        Object.keys(h).forEach(function (k) { try { xhr.setRequestHeader(k, h[k]); } catch (e) {} });
        xhr.upload.onprogress = function (ev) {
          if (ev.lengthComputable) setStatus('Uploading your photo… ' + Math.round(ev.loaded / ev.total * 100) + '%');
        };
        xhr.onload = function () { (xhr.status >= 200 && xhr.status < 300) ? resolve(p.fileUrl) : reject(new Error('PUT ' + xhr.status)); };
        xhr.onerror = function () { reject(new Error('PUT network error')); };
        xhr.send(file);
      });
    }

    // Async upload: presign (retry to ride out a cold/asleep backend) -> PUT -> write fileUrl
    function uploadPhoto(file) {
      clearErr();
      if (urlInput) { urlInput.disabled = false; urlInput.value = ''; }
      input.removeAttribute('name');          // async URL is the source of truth (no native file submit)
      var myGen = ++gen;
      setUploading(true);
      setStatus('Uploading your photo…');

      var attempts = 0;
      function getPresign() {
        attempts++;
        return fetch(PRESIGN_URL, {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ filename: file.name, contentType: file.type, size: file.size })
        }).then(function (r) {
          if (!r.ok) throw new Error('presign ' + r.status);
          return r.json();
        }).catch(function (err) {
          if (attempts < 3) {                 // backend may be waking from sleep — wait and retry
            setStatus('Preparing upload…');
            return new Promise(function (res) { setTimeout(res, 2500 * attempts); }).then(getPresign);
          }
          throw err;
        });
      }

      getPresign()
        .then(function (p) { return putFile(p, file); })
        .then(function (fileUrl) {
          if (myGen !== gen) return;
          if (urlInput) urlInput.value = fileUrl;
          setUploading(false);
          setStatus('✓ Photo uploaded', 'ok');
          thumbFor = fileUrl; rememberThumb();
        })
        .catch(function (err) {
          if (myGen !== gen) return;
          if (window.console && console.warn) console.warn('[mybibblio] photo upload failed:', err);
          setUploading(false);
          setStatus('', null);
          showErr('We couldn’t upload that photo just now — it will still be sent with your order.');
          input.setAttribute('name', photoProp);   // fallback: upload at checkout
          if (urlInput) { urlInput.disabled = true; urlInput.value = ''; }
        });
    }

    function rejectFile(msg) {
      setStatus('', null);
      showErr(msg);
      input.value = ''; prompt.hidden = false; preview.hidden = true; zone.classList.remove('has-photo');
    }

    function proceed(file) {
      if (objectUrl) URL.revokeObjectURL(objectUrl);
      objectUrl = URL.createObjectURL(file);
      thumbData = null; thumbFor = null;
      img.src = objectUrl;
      img.onload = function () {
        if (img.src === objectUrl) { thumbData = makeThumb(img); rememberThumb(); }
        if (img.naturalWidth && img.naturalWidth < 400) {
          showErr('That photo is a little small — a larger one (800px+) will print much better. ');
          if (errEl && !errEl.querySelector('[data-kb-ptips-open]')) {
            var tipLink = document.createElement('button');
            tipLink.type = 'button';
            tipLink.className = 'kb-ptips-link';
            tipLink.setAttribute('data-kb-ptips-open', '');
            tipLink.textContent = 'See photo tips';
            errEl.appendChild(tipLink);
          }
        }
      };
      if (nameEl) nameEl.textContent = file.name || 'photo.jpg';
      prompt.hidden = true; preview.hidden = false; zone.classList.add('has-photo');
      uploadPhoto(file);
    }

    function render(file) {
      clearErr();
      if (!file) return;
      sniffType(file).then(function (kind) {
        var looksHeic = kind === 'heic' || /hei[cf]/i.test(file.type || '') || /\.(heic|heif)$/i.test(file.name || '');
        if (looksHeic) {
          // Try silent auto-conversion first (works on iPhone/Safari) — only bother
          // the customer with the settings message if the browser can't decode it.
          setStatus('Converting your photo…');
          convertHeic(file).then(function (jpeg) { setStatus('', null); proceed(jpeg); })
            .catch(function () { rejectFile(HEIC_MSG); });
          return;
        }
        var okSniff = (kind === 'jpeg' || kind === 'png' || kind === 'webp');
        var okType = OK.indexOf(file.type) !== -1;
        if (!okSniff && !okType) { rejectFile('Please choose a JPG, PNG or WebP image.'); return; }
        proceed(file);
      });
    }

    ['dragenter', 'dragover'].forEach(function (ev) {
      zone.addEventListener(ev, function (e) { e.preventDefault(); zone.classList.add('is-dragging'); });
    });
    ['dragleave', 'dragend', 'drop'].forEach(function (ev) {
      zone.addEventListener(ev, function () { zone.classList.remove('is-dragging'); });
    });
    zone.addEventListener('drop', function (e) {
      var files = e.dataTransfer && e.dataTransfer.files;
      if (files && files.length) {
        e.preventDefault();
        try { input.files = files; } catch (err) {}
        render((input.files && input.files[0]) || files[0]);
      }
    });
    input.addEventListener('change', function () {
      if (input.files && input.files[0]) render(input.files[0]);
    });
    if (thumb) thumb.addEventListener('click', function (e) { e.preventDefault(); openLightbox(objectUrl); });
    if (change) change.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); input.click(); });
    if (remove) remove.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      gen++;
      thumbData = null; thumbFor = null;
      if (objectUrl) { URL.revokeObjectURL(objectUrl); objectUrl = null; }
      input.value = '';
      input.removeAttribute('name');
      img.removeAttribute('src');
      if (nameEl) nameEl.textContent = '';
      if (urlInput) { urlInput.disabled = false; urlInput.value = ''; }
      preview.hidden = true; prompt.hidden = false;
      zone.classList.remove('has-photo');
      setUploading(false); setStatus('', null); clearErr();
    });
  }

  // Child's name: the book fonts only carry Latin glyphs (incl. accents), so anything
  // else (Arabic/Chinese/Cyrillic/emoji…) would silently vanish from the printed pages.
  // The 20-char cap comes from maxlength + the theme's live counter (set in product.json).
  var NAME_MSG = 'Sorry — we can currently only print names using the English alphabet.';
  var nameRe;
  try { nameRe = new RegExp("^[\\p{Script=Latin}\\s'’-]+$", 'u'); }
  catch (e) { nameRe = /^[A-Za-zÀ-ɏ\s'’-]+$/; }   // fallback: Latin-1 + Extended-A

  var NAME_SEL = 'input[name="properties[Child name]"], input[data-kb-name]';
  function setupNameGuard(root) {
    (root || document).querySelectorAll(NAME_SEL).forEach(function (el) {
      if (el.dataset.kbNameInit === '1') return;
      el.dataset.kbNameInit = '1';
      // Real cap is 20 (theme block schema won't go below 25) — the theme's live
      // counter reads input.maxLength, so it shows x/20 automatically.
      el.setAttribute('maxlength', '20');
      var counter = (el.closest('product-custom-property-component') || el.parentNode).querySelector('.__character-count');
      if (counter) {
        var tpl = counter.getAttribute('data-template');
        if (tpl) counter.textContent = tpl.replace('[current]', String(el.value.length)).replace('[max]', '20');
        else counter.textContent = counter.textContent.replace(/\/\s*\d+/, '/20');
      }
      // child-card version: own counter + the card title becomes the child's name
      var ownCount = el.parentNode.querySelector('[data-kb-name-count]');
      var kid = el.closest('[data-kb-kid]');
      var title = kid && kid.querySelector('[data-kb-kid-title]');
      function decorate() {
        if (ownCount) ownCount.textContent = el.value.length + '/20';
        if (title) title.textContent = el.value.trim() || title.getAttribute('data-default') || '';
      }
      el.addEventListener('input', decorate);
      decorate();
      var err = document.createElement('p');
      err.className = 'kb-name-err';
      err.hidden = true;
      err.textContent = NAME_MSG;
      var wrap = el.closest('.__input-wrapper') || el.parentNode;
      if (wrap && wrap.parentNode) wrap.parentNode.insertBefore(err, wrap.nextSibling);
      function check() {
        var bad = el.value !== '' && !nameRe.test(el.value);
        try { el.setCustomValidity(bad ? NAME_MSG : ''); } catch (e) {}
        err.hidden = !bad;
        el.classList.toggle('kb-name-bad', bad);
      }
      el.addEventListener('input', check);
      check();
    });
  }

  // Photo tips popup (open/close via delegated clicks + Escape)
  function ptips() { return document.querySelector('[data-kb-ptips]'); }

  // One-time attention wiggle on the tips pill when it first scrolls into view
  function setupPtipsAttn(root) {
    (root || document).querySelectorAll('.kb-ptips-btn').forEach(function (btn) {
      if (btn.dataset.kbAttnInit === '1') return;
      btn.dataset.kbAttnInit = '1';
      if (!('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        io.disconnect();
        setTimeout(function () {
          btn.classList.add('kb-attn');
          setTimeout(function () { btn.classList.remove('kb-attn'); }, 2000);
        }, 500);
      }, { threshold: 0.6 });
      io.observe(btn);
    });
  }
  document.addEventListener('click', function (e) {
    var t = e.target; if (!t || !t.closest) return;
    if (t.closest('[data-kb-ptips-open]')) {
      e.preventDefault();
      var m = ptips();
      if (m) {
        // Portal the modal to <body>: an ancestor of the form animates with a CSS
        // transform, which would otherwise trap/clip this position:fixed overlay.
        if (m.parentNode !== document.body) document.body.appendChild(m);
        m.hidden = false; document.documentElement.style.overflow = 'hidden';
      }
      return;
    }
    var m2 = ptips();
    if (m2 && !m2.hidden && (t.closest('[data-kb-ptips-close]') || t === m2)) {
      e.preventDefault();
      m2.hidden = true; document.documentElement.style.overflow = '';
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { var m = ptips(); if (m && !m.hidden) { m.hidden = true; document.documentElement.style.overflow = ''; } }
  });

  // Complete-the-trilogy: sibling handles when the trilogy box is ticked
  function trilogyOthers() {
    var el = document.querySelector('[data-mb-trilogy]');
    if (!el || !el.checked) return null;
    var csv = el.getAttribute('data-series-others') || '';
    var arr = csv.split(',').filter(Boolean);
    return arr.length ? arr : null;
  }

  // Copy the text personalisation properties from the form (skips the photo FILE;
  // the async-uploaded photo URL is a text property so it copies too)
  function textProperties(fd) {
    var props = {};
    fd.forEach(function (val, key) {
      var m = /^properties\[(.+)\]$/.exec(key);
      if (m && typeof val === 'string' && val !== '') props[m[1]] = val;
    });
    return props;
  }

  function fetchProductJs(handle) {
    return fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('product ' + handle + ' ' + r.status); return r.json(); });
  }

  // Resolve the sibling books' variant ids matching the selected art style (by SKU suffix)
  function resolveTrilogyItems(fd, others) {
    var handle = (location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1];
    if (!handle) return Promise.reject(new Error('no handle'));
    var mainId = Number(fd.get('id'));
    return fetchProductJs(handle).then(function (p) {
      var mainVar = (p.variants || []).filter(function (v) { return v.id === mainId; })[0];
      var sku = (mainVar && mainVar.sku) || '';
      var suffix = /-flat/.test(sku) ? '-flat' : '-pixar';
      return Promise.all(others.map(function (h) {
        return fetchProductJs(h).then(function (sp) {
          var v = (sp.variants || []).filter(function (x) { return (x.sku || '').indexOf(suffix) !== -1; })[0];
          if (!v) throw new Error('no variant for ' + h + suffix);
          return v.id;
        });
      }));
    });
  }

  // Selected add-on variant ids (checked triggers)
  function activeAddonVariants() {
    var ids = [];
    document.querySelectorAll('[data-mb-addon-trigger]').forEach(function (el) {
      var on = (el.type === 'checkbox' || el.type === 'radio') ? el.checked : false;
      if (on) {
        var v = el.getAttribute('data-addon-variant');
        if (v) ids.push(Number(v));
      }
    });
    return ids;
  }

  function combinedAdd(form, addons, trioOthers) {
    var fd = new FormData(form);           // includes the photo FILE + all book properties
    if (!fd.get('id')) return;
    var childName = fd.get('properties[Child name]') || fd.get("properties[Child's name]") || 'your book';
    var child2 = fd.get('properties[Child 2 name]');
    if (child2) childName = childName + ' & ' + child2;
    var qty = Number(fd.get('quantity')) || 1;
    var addonQty = trioOthers ? 3 : 1;     // hardback/dedication apply to every book in the set

    // Link the book and its paid add-on(s) so removing the book auto-removes the add-ons.
    // Underscore-prefixed => hidden from the cart/checkout line-item display.
    var bundleId = 'kb-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
    if (addons.length) fd.append('properties[_kb_bundle]', bundleId);

    // resolve the trilogy sibling variants first (matching the selected art style)
    var trioPromise = trioOthers
      ? resolveTrilogyItems(fd, trioOthers).catch(function (err) {
          if (window.console && console.warn) console.warn('[mybibblio] trilogy add failed:', err);
          alert('Sorry — we couldn’t add the other two trilogy books automatically. Please add them from their own pages (your 10% discount still applies when all 3 are in the cart).');
          return [];
        })
      : Promise.resolve([]);

    trioPromise.then(function (siblingIds) {
      // 1) add the book via multipart (so the photo uploads to a URL)
      fetch('/cart/add.js', { method: 'POST', body: fd })
        .then(function (r) { return r.json(); })
        .then(function () {
          // 2) add trilogy siblings (same personalisation) + paid add-on(s) in one JSON call
          var props = textProperties(fd);
          var items = siblingIds.map(function (v) {
            return { id: v, quantity: qty, properties: props };
          }).concat(addons.map(function (v) {
            return { id: v, quantity: addonQty, properties: { 'Add-on for': childName, '_kb_bundle': bundleId } };
          }));
          if (!items.length) return null;
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: items })
          });
        })
        .then(function () { return removeOldEditedLine().then(notifyCartUpdated); })
        .catch(function () { return notifyCartUpdated(); });
    });
  }

  // Parental consent: flag red + scroll to it when a buy action is attempted unticked
  function flagConsent() {
    var wrap = document.querySelector('[data-kb-consent]');
    if (!wrap) return;
    wrap.classList.add('is-invalid');
    var err = wrap.querySelector('[data-kb-consent-err]'); if (err) err.hidden = false;
    wrap.classList.remove('kb-shake'); void wrap.offsetWidth; wrap.classList.add('kb-shake');
    try { wrap.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { wrap.scrollIntoView(); }
    var chk = wrap.querySelector('[data-kb-consent-check]'); if (chk) { try { chk.focus({ preventScroll: true }); } catch (e) {} }
  }
  // clear the red state the moment they tick it
  document.addEventListener('change', function (e) {
    var c = e.target;
    if (c && c.matches && c.matches('[data-kb-consent-check]') && c.checked) {
      var wrap = c.closest('[data-kb-consent]');
      if (wrap) { wrap.classList.remove('is-invalid', 'kb-shake'); var err = wrap.querySelector('[data-kb-consent-err]'); if (err) err.hidden = true; }
    }
  });

  // Intercept the add-to-cart / buy CLICK before the theme handles it — capture phase.
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var addBtn = t.closest('button[name="add"], .add-to-cart-button');
    var buyEl = addBtn || t.closest('.shopify-payment-button, .shopify-payment-button__button, [class*="accelerated-checkout"], shopify-accelerated-checkout, shopify-buy-it-now-button');
    if (!buyEl) return;

    // 1) Parental consent must be ticked for ANY buy action (add-to-cart or express checkout)
    var consent = document.querySelector('[data-kb-consent-check]');
    if (consent && !consent.checked) {
      e.preventDefault(); e.stopImmediatePropagation();
      flagConsent();
      return;
    }

    // 1b) Invalid child name blocks ANY buy action too (non-Latin would print as blank).
    //     A removed second child's name is disabled, so its validationMessage is empty.
    var nameInput = null;
    document.querySelectorAll(NAME_SEL).forEach(function (n) {
      if (!nameInput && n.validationMessage === NAME_MSG) nameInput = n;
    });
    if (nameInput) {
      e.preventDefault(); e.stopImmediatePropagation();
      try { nameInput.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (err) {}
      try { nameInput.reportValidity(); } catch (err) {}
      return;
    }

    // 2) Only the add-to-cart button gets the add-on/trilogy takeover
    if (!addBtn) return;
    var form = addBtn.form || addBtn.closest('form');
    if (!form) return;

    // Block add-to-cart while a photo is still uploading — and show the shopper
    // which one, rather than leaving the button silently unresponsive.
    if (form.classList.contains('kb-uploading')) {
      e.preventDefault(); e.stopImmediatePropagation();
      var busy = liveUploads()[0];
      var st = busy && busy.querySelector('[data-kb-photo-status]');
      if (busy) { try { busy.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (err) {} }
      if (st) { st.classList.remove('kb-pulse'); void st.offsetWidth; st.classList.add('kb-pulse'); }
      return;
    }

    var addons = activeAddonVariants();
    var trio = trilogyOthers();
    // Take over when there are add-ons/trilogy, OR when we're editing an existing
    // line (so we can remove the old one after re-adding). Otherwise let the theme add.
    if (!addons.length && !trio && !kbEdit) return;

    // We're taking over: stop the theme's click + native submit so the book isn't added twice.
    e.preventDefault();
    e.stopImmediatePropagation();

    // Preserve required-field validation (photo, dedication, etc.)
    if (typeof form.reportValidity === 'function' && !form.reportValidity()) return;

    combinedAdd(form, addons, trio);
  }, true);

  // Product page only (this file loads only on product pages): open the cart drawer
  // after ANY add — the theme's plain add or our combined add both dispatch 'cart:update'.
  // This never runs on the cart page, so it can't pop the drawer on quantity changes there.
  document.addEventListener('cart:update', function () {
    var drawer = document.querySelector('cart-drawer-component');
    if (drawer && typeof drawer.open === 'function') { try { drawer.open(); } catch (e) {} }
  });

  /* ---- Edit an existing cart line ---------------------------------------
     A cart line's "Edit details" link points here with ?kbedit=<line_key>.
     We pre-fill the personalisation form from that line, and on re-add we
     remove the old line (its add-ons are auto-removed by mybibblio-cart.js). */
  var kbEdit = null;   // { key }

  function kbParam(name) { try { return new URLSearchParams(location.search).get(name); } catch (e) { return null; } }

  function fire(el, type) { try { el.dispatchEvent(new Event(type, { bubbles: true })); } catch (e) {} }

  function selectVariant(line) {
    var wanted = (line.options_with_values || []).map(function (o) { return String(o.value); });
    if (!wanted.length && line.variant_options) wanted = line.variant_options.map(String);
    if (!wanted.length && line.variant_title) wanted = String(line.variant_title).split(' / ').map(function (s) { return s.trim(); });
    if (!wanted.length) return;
    document.querySelectorAll('variant-picker input').forEach(function (r) {
      if (wanted.indexOf(String(r.value)) !== -1 && !r.checked) { r.checked = true; fire(r, 'input'); fire(r, 'change'); }
    });
  }

  function setProperty(name, val) {
    // radios/checkboxes update their :checked CSS + JS listeners via 'change'.
    // (Don't fire 'click' — on a checkbox that would toggle it straight back off.)
    document.querySelectorAll('[name="properties[' + name.replace(/"/g, '') + ']"]').forEach(function (el) {
      if (el.type === 'radio' || el.type === 'checkbox') {
        if (String(el.value) === String(val) && !el.checked) { el.checked = true; fire(el, 'change'); }
      } else { el.value = val; fire(el, 'input'); fire(el, 'change'); }
    });
  }

  function setPhotoUrl(url, prop) {
    if (!url) return;
    var urlInput = document.querySelector('[data-kb-photo-url][name="properties[' + (prop || '_Child photo') + ']"]');
    var root = (urlInput && urlInput.closest('[data-kb-photo]')) || document;
    var photoInput = root.querySelector('[data-kb-photo-input]');
    var zone = root.querySelector('[data-kb-photo-zone]');
    var prompt = root.querySelector('[data-kb-photo-prompt]');
    var preview = root.querySelector('[data-kb-photo-preview]');
    var img = root.querySelector('[data-kb-photo-img]');
    var status = root.querySelector('[data-kb-photo-status]');
    if (urlInput) { urlInput.disabled = false; urlInput.value = url; }
    if (photoInput) {
      photoInput.removeAttribute('name');       // the hidden URL property carries the photo
      photoInput.removeAttribute('required');   // don't force a re-upload of the existing photo (would block validation)
    }
    if (img) img.src = (window.kbThumbs && window.kbThumbs.get(url)) || url;
    if (prompt) prompt.hidden = true;
    if (preview) preview.hidden = false;
    if (zone) zone.classList.add('has-photo');
    if (status) { status.hidden = false; status.textContent = '✓ Using your uploaded photo'; status.className = 'kb-photo__status is-ok'; }
  }

  function enableDedication(msg) {
    var check = document.querySelector('[data-kb-ded-check]');
    if (check && !check.checked) { check.checked = true; fire(check, 'change'); }
    var ta = document.querySelector('[data-kb-dedication] textarea');
    if (ta && msg) { ta.value = msg; fire(ta, 'input'); }
  }

  function setEditButtonLabel() {
    // Only touch the dedicated text node so the button's icon/animation stay intact.
    document.querySelectorAll('.add-to-cart-text__content').forEach(function (el) { el.textContent = 'Update your book'; });
  }

  function prefill(line) {
    // 1) open the personalisation form so the pre-filled answers are visible
    var gate = document.querySelector('[data-mb-gate-btn]');
    if (gate) { try { gate.click(); } catch (e) {} }
    // 2) select the illustration type (variant). This only morphs the variant picker
    //    + media — it does NOT reset the personalisation fields, so filling them next is safe.
    selectVariant(line);
    setTimeout(function () {
      var P = line.properties || {};
      if (P['Child 2 name']) {
        var box = document.querySelector('[data-kb-kids]');
        if (box && box._kbSetKid2) box._kbSetKid2(true, false);
      }
      Object.keys(P).forEach(function (p) {
        if (p === '_Child photo' || p === '_Child 2 photo') { setPhotoUrl(P[p], p); return; }
        if (p.charAt(0) === '_') return;                       // hidden (e.g. _kb_bundle, _Children)
        if (p === 'Dedication') { enableDedication(line.properties[p]); return; }
        if (p === 'Parental consent') return;                  // shopper actively re-confirms consent on edit
        setProperty(p, line.properties[p]);                    // Child name, Reading age, Pronoun, Format(+hardback)
      });
      setEditButtonLabel();
    }, 250);
  }

  function startEditFromCart() {
    var key = kbParam('kbedit');
    if (!key) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var line = (cart.items || []).filter(function (it) { return it.key === key; })[0];
        if (!line) return;
        kbEdit = { key: key };
        prefill(line);
      })
      .catch(function () {});
  }

  function removeOldEditedLine() {
    if (!kbEdit || !kbEdit.key) return Promise.resolve();
    var key = kbEdit.key; kbEdit = null;
    var ids = getCartSectionIds();
    var updates = {}; updates[key] = 0;
    return fetch('/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(ids ? { updates: updates, sections: ids } : { updates: updates })
    }).then(function (r) { return r.json(); }).catch(function () {});
  }

  function init(root) {
    (root || document).querySelectorAll('[data-kb-dedication]').forEach(setupDedication);
    (root || document).querySelectorAll('[data-kb-photo]').forEach(setupPhoto);
    (root || document).querySelectorAll('[data-kb-kids]').forEach(setupKids);
    setupNameGuard(root);
    setupPtipsAttn(root);
  }
  function start() {
    init();
    startEditFromCart();
    try {
      var mo = new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          for (var j = 0; j < muts[i].addedNodes.length; j++) {
            var n = muts[i].addedNodes[j];
            if (n.nodeType === 1) init(n.parentNode || document);
          }
        }
      });
      mo.observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
